import { RequestedVariantType } from "store/types/CreativeAI/shared/Review/review";

export const calculateNoOfAction = (variants: RequestedVariantType[]) => {
  return variants.filter((item) => item.reviewStatus === "UNDER_REVIEW").length;
};
